// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"278656b7","291":"16ad5d0e","321":"f20cbe29","446":"e7ccf13c","757":"6e369f70","830":"38f15aed","941":"626fcf20"}[chunkId] + ".chunk.js";
};